export default {
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  filterOptions: state => state.filterOptions,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  cleanRequest: state => state.cleanRequest,
  cleanVehicle: state => state.cleanVehicle,
  requests: state => state.requests,
  request: state => state.request,
  vinSummary: state => state.vinSummary,
  vrmSummary: state => state.vrmSummary,
  newVehicle: state => state.newVehicle,
  years: state => state.years,
  makes: state => state.makes,
  models: state => state.models,
  jatoMakes: state => state.jatoMakes,
  jatoModels: state => state.jatoModels,
  jatoYears: state => state.jatoYears,
  jatoMakeSelected: state => state.jatoMakeSelected,
  jatoModelSelected: state => state.jatoModelSelected,
  submodels: state => state.submodels,
  engines: state => state.engines,
  transmissions: state => state.transmissions,
  drivetypes: state => state.drivetypes,
  scantypes: state => state.scantypes,
  serviceelements: state => state.serviceelements,
  requestCount: state => state.requestCount,
  statuslist: state => state.statuslist,
  decodeError: state => state.decodeError,
  totalUnreadChats: state => state.totalUnreadChats,
  requestUnreadReset: state => state.requestUnreadReset,
  requestUnreadCount: state => state.requestUnreadCount,
  noRequest: state => state.noRequest,
  mahleApiErrorMsg: state => state.mahleApiErrorMsg,
  ragratingvehicleid: state => state.ragratingvehicleid,
  ragServiceElements: state => state.ragServiceElements,
  ragDeviceTypes: state => state.ragDeviceTypes
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequests/getters.js